import { action } from 'typesafe-actions';
import { SearchTypes } from '../types/search.types';

export const searchRequest = (search, callback) =>
    action(SearchTypes.SEARCH_REQUEST, { search, callback });

export const searchSuccess = data => action(SearchTypes.SEARCH_SUCCESS, data);

export const searchError = () => action(SearchTypes.SEARCH_FAILURE);
